export default {
  isUserLogged(state) {
    const { user } = state;
    return !!(user && user.email);
  },
  loginPolicyContent(state) {
    const { modules } = state.policyContent;
    if (!modules) return null;

    const found = modules.find((x) => x.moduleName === 'LoginHowWeUseYourData');
    return found?.content.unformatted.rows[0].cells[0].content;
  },
  guestPolicyContent(state) {
    const { modules } = state.policyContent;
    if (!modules) return null;

    const found = modules.find((x) => x.moduleName === 'GuestHowWeUseYourData');
    return found?.content.unformatted.rows[0].cells[0].content;
  },
  getGuestEmail(state) {
    return state.guest?.email;
  },
};
